import { ApolloCache, ApolloError, BaseMutationOptions, DefaultContext, OperationVariables, gql, useMutation } from '@apollo/client';
import { GET_CLINICAL_TEAM_CONVERSATION_ID, GET_CONVERSATIONS } from '../../queries';
import { IOkPayload } from '../../types/mutations/generics';

interface IHcCreateClinicalTeamConversationForUserInput {
  athenaId: string;
}

interface IHcCreateClinicalTeamConversationForUserOutput {
  hcCreateClinicalTeamConversationForUser: IOkPayload;
}

const CREATE_CLINICAL_TEAM_CONVO = gql`
  mutation hcCreateClinicalTeamConversationForUser($athenaId: String!) {
    hcCreateClinicalTeamConversationForUser(athenaId: $athenaId) {
      ok
    }
  }
`;

interface IUseCreateClinicalTeamConversation {
  athenaId: string;
  onError?: ((error: ApolloError, clientOptions?: BaseMutationOptions<any, OperationVariables, DefaultContext, ApolloCache<any>> | undefined) => void) | undefined;
  onCompleted?:
    | ((data: IHcCreateClinicalTeamConversationForUserOutput, clientOptions?: BaseMutationOptions<any, OperationVariables, DefaultContext, ApolloCache<any>> | undefined) => void)
    | undefined;
}

export const useCreateClinicalTeamConversation = ({ athenaId, onError, onCompleted }: IUseCreateClinicalTeamConversation) => {
  const [mutate, { data, loading }] = useMutation<IHcCreateClinicalTeamConversationForUserOutput, IHcCreateClinicalTeamConversationForUserInput>(CREATE_CLINICAL_TEAM_CONVO, {
    variables: {
      athenaId,
    },
    refetchQueries: [
      {
        query: GET_CONVERSATIONS,
        variables: {
          status: 'closed',
        },
      },
      {
        query: GET_CONVERSATIONS,
        variables: {
          status: 'open',
        },
      },
      {
        query: GET_CLINICAL_TEAM_CONVERSATION_ID,
        variables: {
          athenaId: athenaId,
        },
      },
    ],
    awaitRefetchQueries: true,
    onError: onError,
    onCompleted: onCompleted,
  });

  return {
    mutate,
    data,
    loading,
  };
};
